export default function normalizeClipboardData( data ) {
	return data
		.replace( /<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, ( fullMatch, spaces ) => {
			// Handle the most popular and problematic case when even a single space becomes an nbsp;.
			// Decode those to normal spaces. Read more in https://github.com/ckeditor/ckeditor5-clipboard/issues/2.
			if ( spaces.length === 1 ) {
				return ' ';
			}

			return spaces;
		} )
		// Remove all HTML comments.
        .replace(/<!--[\s\S]*?-->/g, '')
        // Remove <style> and <script> tags and their content.
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
        // Remove inline styles.
        .replace(/\s*style="[^"]*"/gi, '')
        // Remove <meta> tags.
        .replace(/<meta[^>]*>/gi, '')
        // Remove mso-* styles.
        .replace(/mso-[^:]+:[^;"]*;?/gi, '')
        // Remove unnecessary attributes like `width`, `height`, etc., if needed.
        .replace(/\s*(?:width|height)="[^"]*"/gi, '')
        // Clean up empty elements.
        .replace(/<([a-z][a-z0-9]*)\s*[^>]*>\s*<\/\1>/gi, '')
        // Remove extra spaces between tags.
        .replace(/>\s+</g, '><');
}
